import { SVGS } from '@zonofi/zono-money-design-system';
import React from 'react';

interface RenderCategoriesProps {
  key: number;
  className: string;
  item: any;
  onClick: (val: any) => any;
  buttonName: string;
  hasChildren?: boolean;
}

export const CategoryButton: React.FC<RenderCategoriesProps> = ({
  className,
  item,
  key,
  buttonName,
  onClick,
  hasChildren = false,
}) => {
  return (
    <button key={key} className={className} onClick={() => onClick(item)}>
      {buttonName}
      {hasChildren && <img src={SVGS.RightArrow} alt="" width={4} />}
    </button>
  );
};
